import { apiSlice } from 'src/app/redux/api/apiSlice';
import { SeedsResultType } from 'src/app/redux/seeds/seeds-slice.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const seedsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSeeds: builder.query<SeedsResultType, void>({
      query: () => ({
        url: finalUrlsConfig().seeds,
      }),
      providesTags: [{ type: 'Seeds', id: 'LIST' }],
    }),
  }),
});

export const { useGetSeedsQuery } = seedsSlice;
